import { render, staticRenderFns } from "./NewsTitle.vue?vue&type=template&id=34bed7eb&scoped=true"
import script from "./NewsTitle.vue?vue&type=script&lang=js"
export * from "./NewsTitle.vue?vue&type=script&lang=js"
import style0 from "./NewsTitle.vue?vue&type=style&index=0&id=34bed7eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bed7eb",
  null
  
)

export default component.exports